import { Link } from 'react-router';

import { APPLET_ACCESS_DENIAL_REASON } from '@cartwhl/common/appletPolicy';
import Text from '@cartwhl/ui/base/Text';
import Button from '@cartwhl/ui/input/Button';
import PlayerDialog from '@cartwhl/ui/molecules/PlayerDialog';

import type { AppletAccessDeniedProps } from '../../AppletGuard';

export default function CartographerAccessDeniedDialog({
  reason,
  message,
  signUpUrl,
}: AppletAccessDeniedProps) {
  const actionsClassName =
    reason === APPLET_ACCESS_DENIAL_REASON.anonymous
      ? 'justify-between'
      : 'justify-end';
  const resolvedMessage =
    reason === APPLET_ACCESS_DENIAL_REASON.noApiKey ? (
      <>
        You don&apos;t have an API key. Please{' '}
        <a
          href="mailto:support@getcartwheel.com"
          target="_blank"
          rel="noreferrer"
          className="text-blue underline"
        >
          contact support
        </a>{' '}
        to get access.
      </>
    ) : (
      message
    );

  return (
    <PlayerDialog title="Access required" maxWidth={560}>
      <div className="flex w-full max-w-[460px] flex-col gap-8 text-left sm:min-w-[420px]">
        <Text variant="studio/body/md" className="text-primary text-pretty">
          {resolvedMessage}
        </Text>

        <div className={`flex flex-wrap gap-3 ${actionsClassName}`}>
          <Link to="/">
            <Button variant="secondary" size="lg">
              Back to applets
            </Button>
          </Link>
          {reason === APPLET_ACCESS_DENIAL_REASON.anonymous && (
            <a href={signUpUrl}>
              <Button variant="primary" size="lg">
                Sign up
              </Button>
            </a>
          )}
        </div>
      </div>
    </PlayerDialog>
  );
}
